// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Booking_modal__img__9tMfW {
  height: 7.5rem;
  margin-bottom: 3rem;
}

.Booking_main_nav__CTZ50 {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 2rem;
  padding: 1rem;
  border-top: solid 1px var(--color-primary);
  background-color: var(--color-dark-2);
  box-shadow: 1px 5px 10px -5px rgba(0, 0, 0, 0.3);
  color: var(--color-white);
}
.Booking_main_nav__CTZ50 > :not(:last-child) {
  margin-right: 6rem;
}
.Booking_main_nav_group__BLS0n {
  position: relative;
}
.Booking_main_nav_more__s2lXR {
  position: absolute;
  right: 0;
  top: 75%;
  background-color: var(--color-dark-2);
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  z-index: 5;
}
.Booking_main_nav_more__s2lXR > :not(last-child) {
  margin-bottom: 1rem;
}
.Booking_main_nav_item__tjCac {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
}
.Booking_main_nav_item__tjCac:hover, .Booking_main_nav_item__tjCac:focus, .Booking_main_nav_item__tjCac:focus-visible, .Booking_main_nav_item__tjCac:focus-within {
  font-weight: 700;
  color: var(--color-white);
  border-bottom: solid 2px var(--color-white);
}
.Booking_main_nav_item_active__R1fH0 {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  font-weight: 700;
  color: var(--color-primary-3);
  border-bottom: solid 2px var(--color-primary-3);
}
.Booking_main_nav_item_active__R1fH0:hover, .Booking_main_nav_item_active__R1fH0:focus, .Booking_main_nav_item_active__R1fH0:focus-visible, .Booking_main_nav_item_active__R1fH0:focus-within {
  font-weight: 700;
  color: var(--color-primary-3);
  border-bottom: solid 2px var(--color-primary-3);
}
.Booking_main__content__Lh-p8 {
  margin-top: 5rem;
}
.Booking_main__metrics__fA6Ez {
  box-sizing: border-box;
  padding: 3.5rem 2rem;
  width: 100%;
  display: grid;
  box-sizing: border-box;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}
@media only screen and (max-width: 37.5em) {
  .Booking_main__metrics__fA6Ez {
    grid-template-columns: repeat(2, 50%);
  }
}
.Booking_main__metrics_active__Qq8Ho {
  background-color: var(--color-green);
  color: var(--color-white);
}
.Booking_main__metrics_suspended__14Tfb {
  background-color: var(--color-yellow);
}
.Booking_main__metrics_terminated__qZQIJ {
  background-color: var(--color-error);
  color: var(--color-white);
}
.Booking_main__center__WYGOZ {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Booking_createLinks__6vnEq {
  display: flex;
  justify-content: center;
}
.Booking_createLinks_1__ZT6T4 {
  background-color: var(--color-white);
  padding: 3rem;
  border-radius: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  width: 60%;
}
@media only screen and (max-width: 50em) {
  .Booking_createLinks_1__ZT6T4 {
    width: 100%;
  }
}
.Booking_createLinks_2__TAbfz {
  background-color: var(--color-dark-2);
  padding: 3rem;
  border-radius: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.Booking_createLinks_2__TAbfz img {
  width: 7rem;
}
.Booking_createLinks_mini__-3kA1 {
  background-color: var(--color-white);
  padding: 2rem;
  margin: 1rem 3rem;
  border-radius: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  width: 100%;
}

.Booking_beside__79HL- {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 2rem;
}
@media only screen and (max-width: 31.25em) {
  .Booking_beside__79HL- {
    grid-template-columns: 100%;
  }
}

.Booking_status__pending__i2Z8v {
  color: var(--color-yellow-3);
}
.Booking_status__paid__0ZtvH {
  color: var(--color-green);
}
.Booking_status__failed__vyreD {
  color: var(--color-error);
}

.Booking_active__SnV7N {
  font-weight: 700;
  color: var(--color-green);
}

.Booking_deactivated__I7l\\+2 {
  font-weight: 700;
  color: var(--color-error);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Booking/Booking.module.scss"],"names":[],"mappings":"AAGE;EACE,cAAA;EACA,mBAAA;AAFJ;;AAOE;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,0CAAA;EACA,qCAAA;EAEA,gDAAA;EACA,yBAAA;AALJ;AASI;EACE,kBAAA;AAPN;AAUI;EACE,kBAAA;AARN;AAWI;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,qCAAA;EACA,eAAA;EACA,mBAAA;EACA,4CAAA;EACA,UAAA;AATN;AAWM;EACE,mBAAA;AATR;AAaI;EACE,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;AAXN;AAiBM;EAIE,gBAAA;EACA,yBAAA;EACA,2CAAA;AAlBR;AAqBM;EACE,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;EACA,gBAAA;EACA,6BAAA;EACA,+CAAA;AAnBR;AAyBQ;EAIE,gBAAA;EACA,6BAAA;EACA,+CAAA;AA1BV;AAgCE;EACE,gBAAA;AA9BJ;AAiCE;EACE,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,SAAA;AA/BJ;AAiCI;EATF;IAUI,qCAAA;EA9BJ;AACF;AAgCI;EACE,oCAAA;EACA,yBAAA;AA9BN;AAiCI;EACE,qCAAA;AA/BN;AAkCI;EACE,oCAAA;EACA,yBAAA;AAhCN;AAoCE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAlCJ;;AAsCA;EACE,aAAA;EACA,uBAAA;AAnCF;AAqCE;EACE,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,4CAAA;EAEA,UAAA;AApCJ;AAsCI;EARF;IASI,WAAA;EAnCJ;AACF;AAsCE;EACE,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,4CAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AApCJ;AAsCI;EACE,WAAA;AApCN;AAwCE;EACE,oCAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,4CAAA;EACA,WAAA;AAtCJ;;AA0CA;EACE,aAAA;EACA,SAAA;EACA,qCAAA;EACA,mBAAA;AAvCF;AAyCE;EANF;IAOI,2BAAA;EAtCF;AACF;;AA0CE;EACE,4BAAA;AAvCJ;AA0CE;EACE,yBAAA;AAxCJ;AA2CE;EACE,yBAAA;AAzCJ;;AA6CA;EACE,gBAAA;EACA,yBAAA;AA1CF;;AA6CA;EACE,gBAAA;EACA,yBAAA;AA1CF","sourcesContent":["@import \"../variables/breakpoints\";\n\n.modal {\n  &__img {\n    height: 7.5rem;\n    margin-bottom: 3rem;\n  }\n}\n\n.main {\n  &_nav {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    margin-top: 2rem;\n    padding: 1rem;\n    border-top: solid 1px var(--color-primary);\n    background-color: var(--color-dark-2);\n    // background-color: var(--color-fash-primary-2);\n    box-shadow: 1px 5px 10px -5px rgba(0, 0, 0, 0.3);\n    color: var(--color-white);\n    // border-bottom: solid 1px var(--color-dark);\n    // border-radius: 1rem 1rem 0 0;\n\n    & > :not(:last-child) {\n      margin-right: 6rem;\n    }\n\n    &_group {\n      position: relative;\n    }\n\n    &_more {\n      position: absolute;\n      right: 0;\n      top: 75%;\n      background-color: var(--color-dark-2);\n      padding: 1.5rem;\n      border-radius: 1rem;\n      box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n      z-index: 5;\n\n      & > :not(last-child) {\n        margin-bottom: 1rem;\n      }\n    }\n\n    &_item {\n      cursor: pointer;\n      padding: 1rem 0;\n      box-sizing: border-box;\n      font-size: var(--default-font-small);\n\n      // @media only screen and (max-width: $bp-600) {\n      // \twidth: 47%;\n      // }\n\n      &:hover,\n      &:focus,\n      &:focus-visible,\n      &:focus-within {\n        font-weight: 700;\n        color: var(--color-white);\n        border-bottom: solid 2px var(--color-white);\n      }\n\n      &_active {\n        cursor: pointer;\n        padding: 1rem 0;\n        box-sizing: border-box;\n        font-size: var(--default-font-small);\n        font-weight: 700;\n        color: var(--color-primary-3);\n        border-bottom: solid 2px var(--color-primary-3);\n\n        // @media only screen and (max-width: $bp-600) {\n        // \twidth: 47%;\n        // }\n\n        &:hover,\n        &:focus,\n        &:focus-visible,\n        &:focus-within {\n          font-weight: 700;\n          color: var(--color-primary-3);\n          border-bottom: solid 2px var(--color-primary-3);\n        }\n      }\n    }\n  }\n\n  &__content {\n    margin-top: 5rem;\n  }\n\n  &__metrics {\n    box-sizing: border-box;\n    padding: 3.5rem 2rem;\n    width: 100%;\n    display: grid;\n    box-sizing: border-box;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 2rem;\n\n    @media only screen and (max-width: $bp-600) {\n      grid-template-columns: repeat(2, 50%);\n    }\n\n    &_active {\n      background-color: var(--color-green);\n      color: var(--color-white);\n    }\n\n    &_suspended {\n      background-color: var(--color-yellow);\n    }\n\n    &_terminated {\n      background-color: var(--color-error);\n      color: var(--color-white);\n    }\n  }\n\n  &__center {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\n.createLinks {\n  display: flex;\n  justify-content: center;\n\n  &_1 {\n    background-color: var(--color-white);\n    padding: 3rem;\n    border-radius: 2rem;\n    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\n    width: 60%;\n\n    @media only screen and (max-width: $bp-800) {\n      width: 100%;\n    }\n  }\n\n  &_2 {\n    background-color: var(--color-dark-2);\n    padding: 3rem;\n    border-radius: 2rem;\n    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    img {\n      width: 7rem;\n    }\n  }\n\n  &_mini {\n    background-color: var(--color-white);\n    padding: 2rem;\n    margin: 1rem 3rem;\n    border-radius: 2rem;\n    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n    width: 100%;\n  }\n}\n\n.beside {\n  display: grid;\n  gap: 2rem;\n  grid-template-columns: repeat(2, 1fr);\n  margin-bottom: 2rem;\n\n  @media only screen and (max-width: $bp-500) {\n    grid-template-columns: 100%;\n  }\n}\n\n.status {\n  &__pending {\n    color: var(--color-yellow-3);\n  }\n\n  &__paid {\n    color: var(--color-green);\n  }\n\n  &__failed {\n    color: var(--color-error);\n  }\n}\n\n.active {\n  font-weight: 700;\n  color: var(--color-green);\n}\n\n.deactivated {\n  font-weight: 700;\n  color: var(--color-error);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal__img": `Booking_modal__img__9tMfW`,
	"main_nav": `Booking_main_nav__CTZ50`,
	"main_nav_group": `Booking_main_nav_group__BLS0n`,
	"main_nav_more": `Booking_main_nav_more__s2lXR`,
	"main_nav_item": `Booking_main_nav_item__tjCac`,
	"main_nav_item_active": `Booking_main_nav_item_active__R1fH0`,
	"main__content": `Booking_main__content__Lh-p8`,
	"main__metrics": `Booking_main__metrics__fA6Ez`,
	"main__metrics_active": `Booking_main__metrics_active__Qq8Ho`,
	"main__metrics_suspended": `Booking_main__metrics_suspended__14Tfb`,
	"main__metrics_terminated": `Booking_main__metrics_terminated__qZQIJ`,
	"main__center": `Booking_main__center__WYGOZ`,
	"createLinks": `Booking_createLinks__6vnEq`,
	"createLinks_1": `Booking_createLinks_1__ZT6T4`,
	"createLinks_2": `Booking_createLinks_2__TAbfz`,
	"createLinks_mini": `Booking_createLinks_mini__-3kA1`,
	"beside": `Booking_beside__79HL-`,
	"status__pending": `Booking_status__pending__i2Z8v`,
	"status__paid": `Booking_status__paid__0ZtvH`,
	"status__failed": `Booking_status__failed__vyreD`,
	"active": `Booking_active__SnV7N`,
	"deactivated": `Booking_deactivated__I7l+2`
};
export default ___CSS_LOADER_EXPORT___;
